import { connect } from "react-redux";
import { SkipSection as Component } from "./SkipSection";
import { setNoteBookSection } from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    toNextSection: (section) => {
      dispatch(setNoteBookSection(section));
    },
  };
}

export const SkipSection = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
